export const carerTrackingFeaturesList = [
    {
        id: '1',
        title: 'Emergency Alert',
        content: 'If your loved one needs urgent help, they can send you an alert with a single tap, so you know right away if something’s wrong, and you have their exact location to hand.',
        imgName: 'newEmergencyAlertCaousell'

    },
    {
        id: '2',
        title: 'Battery Monitoring',
        content: "Save the stress if they aren’t picking up their phone. You can check if their battery is low directly from the app and remind them to charge it with in-built messaging.",
        imgName: 'carrersBattery'
    },
    {
        id: '3',
        title: 'Location History',
        content: "Seeing where they’ve been throughout the day is helpful for tracking routines and any unusual changes.",
        imgName: 'locationHistoryCarousel'
    },
    {
        id: '4',
        title: 'Geofence Alerts',
        content: 'Set up alerts for key locations, like home or a care facility. Get notified if they unexpectedly leave or arrive somewhere.',
        imgName: 'familyCarousel'
    },
];